export default {
  save: { id: 'save' },
  cancel: { id: 'cancel' },
  digitalLogbook: { id: 'digital_logbook' },
  eventCategory: { id: 'event_category' },
  event: { id: 'event' },
  result: { id: 'result' },
  status: { id: 'status' },
  unitItem: { id: 'unit' },
  eventForm: { id: 'event_form' },
  selectSite: { id: 'select_site' },
  selectDate: { id: 'select_date' },
  startTime: { id: 'start_time' },
  endTime: { id: 'end_time' },
  category: { id: 'category' },
  locus: { id: 'locus' },
  selectLocus: { id: 'select_locus' },
  selectLocusGroup: { id: 'select_locus_group' },
  addComment: { id: 'add_comment' },
  attachmentFile: { id: 'attachment_file' },
  uploadPdfPngJpg: { id: 'upload_Pdf_Png_Jpg' },
  editUserData: { id: 'edit_user_data' },
  noRecordedEvents: { id: 'no_recorded_events' },
  site: { id: 'site' },
  cage: { id: 'cage' },
  unit: { id: 'locus' },
  createEvent: { id: 'create_event' },
  updateEvent: { id: 'change_event_form' },
  eventInfo: { id: 'event_info' },
  eventCreate: { id: 'event_create' },
  eventEdit: { id: 'event_edit' },
  eventDelete: { id: 'event_delete' },
  deleteEvent: { id: 'delete_event' },
  deleteEventMessage: { id: 'delete_event_message' },
  eventCreator: { id: 'event_creator' },
  lastEventInfoUpdate: { id: 'last_event_info_update' },
  comment: { id: 'comment' },
  dateCreated: { id: 'create_date' },
  dateUpdated: { id: 'date_updated' },
  updatedBy: { id: 'updated_by' },
  date: { id: 'date' },
  time: { id: 'time' },
  savedEntry: { id: 'saved_logbook_entry' },
  changedEntry: { id: 'changed_logbook_entry' },
  locusGroup: { id: 'locus_group' },
  fileNotUploadMessage: { id: 'file_not_upload_message' },
  eventDate: { id: 'event_date' },
  file: { id: 'file' },
  updatedTime: { id: 'updated_time' },
  eventDetails: { id: 'event_details' },
  history: { id: 'history' },
  audit: { id: 'audit' },
}
